import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import * as styles from './RulerButton.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var RulerButton = function RulerButton(_ref) {
  var ruler = _ref.ruler,
    control = _ref.control;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isRulerPressed = _React$useState2[0],
    setRulerPressed = _React$useState2[1];
  var toggleRuler = React.useCallback(function () {
    var type = control.type,
      onClick = control.onClick;
    if (onClick) {
      onClick({
        type: type
      });
    }
    var enabled = ruler.isEnabled();
    if (!enabled) {
      ruler.enable();
      setRulerPressed(true);
    } else {
      ruler.close();
      ruler.disable();
      setRulerPressed(false);
    }
  }, [ruler, control]);
  var classNames = [styles['ruler-button']];
  if (isRulerPressed) {
    classNames.push(styles['pressed']);
  }
  return /*#__PURE__*/_jsx("button", {
    onClick: toggleRuler,
    className: classNames.join(' '),
    children: /*#__PURE__*/_jsx("div", {
      className: styles['icon']
    })
  });
};